import { Authentication } from './core/baseRequest';
import { BaseGetRequest } from '.';
import { ModificationRequestsList, ModificationRequestsListDynamicType } from '../models/bookingModificationRequestsList';

export class GetPastModificationsRequest extends BaseGetRequest<ModificationRequestsList> {
    constructor(public bookingId: string) {
        super(`bookings/${bookingId}/modification-requests`, {}, ModificationRequestsListDynamicType, Authentication.SharingToken);
    }
}
